import { createSelector } from 'reselect'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'

interface CheckoutLoyaltyEarnOrderContext {
  orderId: string
  bookingDate: string
  /** The order's region, which decides the payment-method earn instead of the region being browsed */
  region: string
}

/**
 * The original order behind a post-purchase checkout, sent with its earn requests so svc-lux-loyalty
 * can apply the earn rules from when, and where, the order was booked.
 */
const getCheckoutLoyaltyEarnOrderContext = createSelector(
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => state.checkout.cart.existingOrder,
  (postPurchaseMode, existingOrder): CheckoutLoyaltyEarnOrderContext | undefined => {
    if (!postPurchaseMode || !existingOrder) return undefined

    return {
      orderId: existingOrder.id,
      bookingDate: existingOrder.createdAt,
      region: existingOrder.regionCode,
    }
  },
)

export default getCheckoutLoyaltyEarnOrderContext
